import { useQuery } from 'react-query';
import { useServiceError } from '@/hooks';
import { getHelpArea, listHelpAreas } from './HelpAreas.service';
import { HelpAreaQuery } from './HelpAreas.types';
import notificationError from '@/utils/functions/notificationError';
import { queryClient } from '@/Root';

export function useHelpAreas(params?: HelpAreaQuery) {
  const cache = queryClient.getQueryData(['helpareas', { ...params }]);

  return useQuery({
    queryKey: ['helpareas', { ...params }],
    queryFn: () => listHelpAreas(params),
    onError(error) {
      notificationError(error);
    },
    enabled: !cache,
  });
}

export function useHelpArea(helpAreaId?: number) {
  const query = useQuery(
    ['helpareas', helpAreaId],
    () => getHelpArea(helpAreaId),
    { enabled: !!helpAreaId },
  );
  useServiceError(query.error);
  return query;
}
